<div class="app-container">
  <app-header></app-header>
  <app-stepper></app-stepper>
  <main class="main-content">
    <router-outlet />
  </main>
</div>

<div class="toast-wrapper">
  <app-toast
    *ngFor="let toast of toasts"
    [toast]="toast"
    (close)="onToastClose(toast.id)"
  />
</div>
